import { LocaleType } from "./LocaleType";

const cs: LocaleType = {
    loading: "Načítám",
    about: "O aplikaci",
    tutorial: "Návod",
    send: "Odeslat kresbu",
    welcome: "Vítejte",
    onboarding: "Úvod",
    connected: "Připojeno",
    disconnected: "Odpojeno",
    strange_noises: "Podivné zvuky",

    your_nick: "Tvá přezdívka...",

    you_can_start_anew: "Začni znovu...",
    welcome_back: "Vítejte zpět",

    draw_something_special: "Nakresli linku jedním tahem!",

    blocked_notice: "Byl/a jsi permanentně zablokován/a.",
    rejected_notice: "Mám pocit, že kreslíš něco nevhodného. Zkus to znovu, prosím.",
    accepted_notice: "Obrázek jsme zkontrolovali a je v pohodě, díky!",

    anonymous_mode_notice: "Tato aplikace nefunguje v anonymním režimu.",
    connection_error: "Chyba připojení",

    about_you: "O tobě",
    about_you_hint: "Tato aplikace je anonymní, ale můžeš nám o sobě něco říct, pokud chceš. Třeba jakou máš rád/a barvu, nebo co tě přivedlo sem. Tvoje informace nám pomůžou pochopit, kdo naši aplikaci používá a jak ji můžeme zlepšit.",

    select_color: "Vyber barvu",
    too_short_notice: "To bylo moc krátké - zkus delší čáru!",
    too_small_notice: "Nakresli něco většího!"
}

export default cs;